export default {
  banners: [
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
    {
      imgUrl: require("../../assets/images/contact/contact-banner.jpg"),
      title: "",
      description: "",
      component: ""
    }
  ],
  contactUs: "联系我们",
  a1: `成都市天府软件园D6-13层(中国)`,
  a2: `Bellevue, Washington, 98004, United States of America`,
  p1: `+86(028) 6593-5363 (中国）`,
  p2: `+86 15928758550 (中国）`,
  p3: `+86 400-871-8663 (中国）`,
  p4: `+86 18349353270（中国）`,
  p5: `+880 1825459736 (孟加拉国）`,
  p6: `+1 4258668398 (美国）`,
  tips: `最有效的联系方式是使用右下角即时通讯窗口。`,
  map: require("../../assets/images/contact/map.png"),

  info: "MaesInfo与客户建立持久的关系，以创造价值并加速发展他们的数字转型之旅。",
  address: [
    {
      title: "成都，中国",
      info: `地址:成都市天府软件园D6-13层 610041 <br/>
              电话:+86 (28) 6593-5363 <br/>
              传真: +86(28) 8533-6315 <br/>
              邮箱: sales@maesinfo.cn`
    },
    {
      title: "深圳，中国",
      info: ""
    },
    {
      title: "常州，中国",
      info: ""
    },
    {
      title: "华盛顿，美国",
      info: ""
    }
  ],
  qrCode: {
    qrImg: require("../../assets/images/contact/qrcode.png"),
    title: "iPhone  Android",
    description: "通过Me来联系我们",
    url: "https://www.melinked.com"
  }
};
